import {useMemo} from 'react'

import {useTaskDescription} from '../task-description-store'
import {UserAccess} from '@extensions/user-access'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {globals} from '@extensions/globals-base'
import {Sync} from '@client/sync'
import {newsCompanyId} from 'yougile-model'

export type UsersMap = {[userId: string]: UserProxy}

export const useGetPreparedUsers = (): UsersMap => {
  const [state, store] = useTaskDescription()

  const projectId = useMemo(() => {
    const box = Sync.getCurrentSandbox()
    const hub = store.taskHub

    if (hub.companyId === newsCompanyId) {
      return newsCompanyId
    }

    const proj = box.getProjectFor(store.taskHub.id)
    return proj?.id
  }, [store.taskHub.id])

  const projectUsers = useMemo(() => {
    if (!projectId || projectId === newsCompanyId) {
      const box = Sync.getCurrentSandbox()
      return box.getAllUsers(false)
    }

    return UserAccess.listUsersInProject({
      id: projectId,
      companyId: globals.getCompanyId()
    })
  }, [projectId])

  const taskUsers = useMemo(() => {
    return state.historyList.map(h => h.userId)
  }, [store.taskHub.id, state.historyList.length])

  const users = useMemo(
    () =>
      projectUsers
        .filter(user => taskUsers.includes(user.id))
        .reduce((acc, curr) => {
          if (!acc[curr.id]) {
            acc[curr.id] = UserProxy.create(curr)
          }

          return acc
        }, {} as UsersMap),
    [taskUsers, projectUsers]
  )

  return users
}
